import { useState, useEffect } from 'react';
import * as Yup from 'yup';
import { LoadingButton } from '@mui/lab';

// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { Container, Grid, Paper, Typography, Alert } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { useSettingsContext } from '../../components/settings';
import FormProvider, { RHFAutocomplete } from '../../components/hook-form';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { onAddComorbidity,onUpdateComorbidity } from '../../APIs/comorbidities';
import { GridPaper, GridPaperSelect, GridPaperSwitch } from '../../components/custom-grid-input';

const classes = {
    root: {
        flexGrow: 1
    },
    paper: {
        padding: 5,
        textAlign: "center",
        color: "inherit"
    }
};

/* eslint-disable react/prop-types */
const ComorbiditiesView = ({ onChange, item, onHandleClose,  readOnly = true }) => {
    const { themeStretch } = useSettingsContext();
    const axiosPrivate = useAxiosPrivate();
    
    const AddComorbiditySchema = Yup.object().shape({
        id: Yup.number(),
        name: Yup.string().max(58).required('Name is required'),        
        keywords:Yup.string().max(230),        
        isActive: Yup.boolean()                
    });

    const defaultValues = {
        id: item?.id ?? 0,
        name: item?.name ?? '',        
        isActive: item?.isActive ?? true,             
        keywords:item?.keywords ?? ''        
    };

    const methods = useForm({
        resolver: yupResolver(AddComorbiditySchema),
        defaultValues
    });

    const {
        setValue,
        reset,
        setError,
        handleSubmit,
        formState: { errors, isSubmitting, isSubmitSuccessful },
    } = methods;

    const handleSave = (request) => {
        const newRequest = { ...request }

        if (request.id > 0) {
            updateComorbidity(newRequest);
        }
        else {
            addComorbidity(newRequest);
        }
    }

    const addComorbidity = (request) => {
        onAddComorbidity(axiosPrivate, request, (response) => {
            if (response.status === 201) {
                onChange(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }

    const updateComorbidity = (request) => {
        onUpdateComorbidity(axiosPrivate, request, (response) => {
            if (response.status === 200) {
                onChange(response.data);
            }
            else {
                console.log('error', response);

                reset();

                setError('afterSubmit', {
                    ...response,
                    message: response.data,
                });
            }
        });
    }
    
    return (
        <>
            <Helmet>
                <title>View Comorbidity | flok</title>
            </Helmet>

            <Container maxWidth={themeStretch ? false : 'xl'} spacing={{ xs: 0.5, sm: 1.5 }}>
                <FormProvider methods={methods} onSubmit={handleSubmit(handleSave)}>
                    <div style={classes.root}>
                        <Grid container item xs={12} spacing={1}>
                            <Grid item xs={12}>
                                <Typography variant="h4" component="h4" paragraph>
                                    {readOnly ? 'View Comorbidity' : `${item ? 'Update' : 'Add'} Comorbidity`}
                                </Typography>
                                {!!errors.afterSubmit && <Alert severity="error">{errors.afterSubmit.message}</Alert>}
                            </Grid>
                            <GridPaper name="name" label='Name' xs={12} readOnly={readOnly} />
                            <GridPaper name="keywords" label='Keywords' xs={12} readOnly={readOnly} />                                                                                 
                            <GridPaperSwitch name="isActive" label='Is Active' xs={3} readOnly={readOnly} />                                                        
                            <Grid container item xs={12} spacing={1}>
                                <Grid item xs={2}>
                                    <Paper style={classes.paper}>
                                        {!readOnly &&
                                            <LoadingButton
                                                type="submit"
                                                variant="contained"
                                                loading={isSubmitSuccessful || isSubmitting}
                                            >
                                                {item ? "Update" : "Add"}
                                            </LoadingButton>
                                        }
                                    </Paper>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </FormProvider>
            </Container>
        </>
    )
}

export default ComorbiditiesView;